import ProfileIcon from '../../assets/images/general-user.svg';
import CloseSession from '../../assets/images/cerrar-sesion.svg';
import WithoutNotificationsIcon from '../../assets/images/wthout-notifications-bell.svg';
import { useEffect, useState } from 'react';
import { useUserName } from '../../contexts/userName';
import seedsLogo from '../../assets/images/seeds-def.png';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';

// menu
import Arrow from '../../assets/images/right-arrow.svg';
import MapIcon from '../../assets/images/map-black.svg';
import PeopleIcon from '../../assets/images/people-dark.svg';
import StartIcon from '../../assets/images/star-dark.svg';
import Out from '../../assets/images/out.svg';
import School from '../../assets/icons/hatSchoolBlue.svg';
import { logoutUser } from '../../API/apiService';
import {
  getSessionHomeRoute,
  isAdminRole,
  isLogisticsRole,
  isReviewerRole,
  isSuperadminRole
} from '../../utils/session';

function Header() {
  const { userName, userRole, clearCache } = useUserName();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const isAdmin = isAdminRole(userRole);
  const isReviewer = isReviewerRole(userRole);
  const isSuperadmin = isSuperadminRole(userRole);
  const isLogistics = isLogisticsRole(userRole);
  // METHODS //
  async function Logout() {
    await logoutUser();
    clearCache();
    openMenu(false);
    navigate('/login');
  }

  function goToHome() {
    navigate(getSessionHomeRoute(userRole));
  }

  function openMenu(open) {
    const root = document.querySelector(':root');
    root.style.setProperty('--vertical-menu-display', 'unset');
    setTimeout(() => setMenuOpen(open), 10);
  }

  useEffect(() => {
    const root = document.querySelector(':root');
    if (!menuOpen) {
      setTimeout(() => {
        root.style.setProperty('--vertical-menu-display', 'none');
      }, 650);
    }
  }, [menuOpen]);
  return (
    <>
      <section className='header'>
        <img src={seedsLogo} alt='logo' className='header__logo' />
        <div className='header__menu-mobile'>
          <input
            type='checkbox'
            id='menuTrigger'
            checked={menuOpen}
            onChange={event => openMenu(event.target.checked)}
          />
          <label htmlFor='menuTrigger' className='toggle'>
            <div className='bars' id='bar1'></div>
            <div className='bars' id='bar2'></div>
            <div className='bars' id='bar3'></div>
          </label>
          <div className='side-menu'>
            <div className='side-menu__wrapper content'>
              <div className='content__header head'>
                <span className='head__title'>Menu</span>
              </div>
              <div className='content__actions action'>
                {isSuperadmin ? (
                  <Link
                    to='/superadmin'
                    onClick={() => openMenu(false)}
                    className='action__wrapper field'>
                    <span className='material-symbols-rounded field__icon'>
                      admin_panel_settings
                    </span>
                    <span className='field__name'>Panel Superadmin</span>
                    <img src={Arrow} alt='...' className='field__arrow' />
                  </Link>
                ) : isAdmin ? (
                  <>
                    <div className='action__wrapper field'>
                      <img
                        src={PeopleIcon}
                        alt='people icon'
                        className='field__icon'
                      />
                      <span className='field__name'>
                        Centro de Orientación Pedagógica
                      </span>
                      <img src={Arrow} alt='...' className='field__arrow' />
                    </div>
                    <Link
                      to={'/administrador/menu'}
                      onClick={() => openMenu(false)}
                      className='action__wrapper field'>
                      <img
                        src={StartIcon}
                        alt='star icon'
                        className='field__icon'
                      />
                      <span className='field__name'>
                        Proceso Formativo de Participación Ciudadana
                      </span>
                      <img src={Arrow} alt='...' className='field__arrow' />
                    </Link>
                    <div className='action__wrapper field'>
                      <img
                        src={MapIcon}
                        alt='map icon'
                        className='field__icon'
                      />
                      <span className='field__name'>
                        Consejos Estudiantiles Comunales
                      </span>
                      <img src={Arrow} alt='...' className='field__arrow' />
                    </div>
                  </>
                ) : isReviewer ? (
                  <Link
                    to='/revisor'
                    onClick={() => openMenu(false)}
                    className='action__wrapper field'>
                    <span className='material-symbols-rounded field__icon'>
                      verified_user
                    </span>
                    <span className='field__name'>Centro de revisión</span>
                    <img src={Arrow} alt='...' className='field__arrow' />
                  </Link>
                ) : isLogistics ? (
                  <Link
                    to='/logistica'
                    onClick={() => openMenu(false)}
                    className='action__wrapper field'>
                    <span className='material-symbols-rounded field__icon'>
                      inventory_2
                    </span>
                    <span className='field__name'>Gestión logística</span>
                    <img src={Arrow} alt='...' className='field__arrow' />
                  </Link>
                ) : (
                  <>
                    <Link
                      to={'/escuelas'}
                      onClick={() => openMenu(false)}
                      className='action__wrapper field'>
                      <img
                        src={School}
                        alt='hat icon'
                        className='field__icon'
                      />
                      <span className='field__name'>Proceso Formativo</span>
                      <img src={Arrow} alt='...' className='field__arrow' />
                    </Link>
                    <Link
                      to={'/calendario'}
                      onClick={() => openMenu(false)}
                      className='action__wrapper field'
                    >
                      <img
                        src={PeopleIcon}
                        alt='people icon'
                        className='field__icon'
                      />
                      <span className='field__name'>Calendario</span>
                      <img src={Arrow} alt='...' className='field__arrow' />
                    </Link>
                  </>
                )}
                <div className='action__wrapper field' onClick={() => Logout()}>
                  <img src={Out} alt='user icon' className='field__icon' />
                  <span className='field__name'>Salir</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className='header__slogan'>unidad de gestión formativa</span>
        <div className='header__user user'>
          <span className='user__name'>{userName}</span>
          <span className='user__role'>{userRole}</span>
          <img
            src={ProfileIcon}
            alt='user icon'
            onClick={() => goToHome()}
            className='user__img'
          />
        </div>
        <div className='header__notifications noti'>
          <img
            src={WithoutNotificationsIcon}
            alt='wthout notifications'
            className='noti__icon'
          />
        </div>
        {isSuperadmin && (
          <Link
            to='/superadmin/usuarios'
            className='header__users'
            aria-label='Administrar usuarios'
            title='Usuarios'>
            <img src={PeopleIcon} alt='' className='header__users-icon' />
          </Link>
        )}
        <div className='header__logout logout' onClick={() => Logout()}>
          <img src={CloseSession} alt='logout' className='logout__icon' />
        </div>
      </section>
    </>
  );
}

export default Header;
